import { HomeComponent } from './../home/home.component';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { GLOBAL } from 'src/app/services/global';
@Component({
  selector: "page-auxUrl",
  templateUrl: "auxUrl.component.html",
  styleUrls: ["./auxUrl.component.css"]
})

export class AuxUrlComponent {
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
  public filedomSeguimientoSol = GLOBAL.filedomSeguimientoSol;
  public generico = GLOBAL.generico;
  public ingresoExpedientes = GLOBAL.ingresoExpedientes;
  public isTest = GLOBAL.isTest;

  constructor(private dialog: MatDialog, private _router: Router) {

  }
  sign(tipo) {
    //  alert(tipo);
    if (sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")) {
      this.dialog.closeAll();
      if (tipo == 'expediente') {
        this._router.navigate([`/expedientes`]);
      } else if (tipo == 'seguimiento_expediente') {
        window.open(`${GLOBAL.seguimientoSolicitudes}`, "_blank")
        // this._router.navigate([`/seguimiento_expediente`]);
      } else if (tipo == 'derecho') {
        this._router.navigate([`/pago_calculo_derecho`]);
      } else if (tipo == 'ingreso-obs') {
        this._router.navigate([`/ingreso_observaciones`]);
      }
    } else {
      this.dialog.closeAll();
      if (tipo == 'expediente') {
        localStorage.setItem("navdomcloud", 'expedientes')
        this.dialog.open(HomeComponent, {
          width: '70%',
          maxWidth: '450px',
          data: {
            url: 'expedientes'
          }
        })
      } else if (tipo == 'seguimiento_expediente') {
        localStorage.setItem("navdomcloud", 'seguimiento_expediente')
        window.open(`${GLOBAL.seguimientoSolicitudes}`, "_blank")

      } else if (tipo == 'derecho') {

        window.open(`/#/pago_calculo_derecho`, '_blank');

      } else if (tipo == 'ingreso-obs') {

        this._router.navigate([`/ingreso_observaciones`]);

      }
    }
  }
  /*sign(){
      if(sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")){
          this.dialog.closeAll();
          this._router.navigate([`/expedientes`]);
  
        } else {
          localStorage.setItem("navdomcloud", 'expedientes')
          this.dialog.open(HomeComponent,{
            data: {
              url: 'expedientes'
            }
          })
        }
        }*/
}
